import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

interface ImpressionFieldObject {
  id: string;
  name: string;
  list?: string;
  brand?: string;
  category?: string;
  variant?: string;
  position?: number;
  price?: number;
}

@Injectable()
export class EcommerceService {
  public FS = (<any>window).FS;
  public dataLayer = (<any>window).dataLayer;
  public cg_convert = (<any>window).cg_convert;

  constructor(
    @Inject('$log') private $log,
    @Inject('$filter') private $filter,
  ) {}

  pageview(path: string) {
    const data = {
      event: 'virtualPageView',
      virtualPageViewPath: path,
    };

    this.pushData(data);
  }

  productImpressions(products: ImpressionFieldObject[]) {
    const data = {
      ecommerce: {
        impressions: products || [],
      },
    };

    this.pushData(data);
  }

  addToCart(cart) {
    const data = {
      event: 'productAddToCart',
      ecommerce: {
        currencyCode: 'USD',
        add: {
          products: this.mapProducts(cart),
        },
      },
    };

    this.pushData(data);
  }

  checkout(step: number, cart) {
    if (typeof step !== 'number') {
      return false;
    }

    const data = {
      event: 'productCheckout',
      ecommerce: {
        checkout: {
          actionField: { step },
          products: this.mapProducts(cart),
        },
      },
    };

    this.pushData(data);
  }

  conversion(orderNumber: string, orderTotal: number) {
    // Send conversion to GTM
    const data = {
      event: 'purchase',
      orderCurrency: 'USD',
      orderId: orderNumber || 'N/A',
      orderTotal: orderTotal || 1.50,
    };

    this.pushData(data);

    if (typeof this.cg_convert === 'function') {
      this.cg_convert(`${orderNumber}, ${orderTotal}`);
    }
  }

  purchase(purchaseData, cart) {
    const data = {
      event: 'transactionSuccess',
      ecommerce: {
        currencyCode: 'USD',
        purchase: {
          actionField: purchaseData,
          products: this.mapProducts(cart),
        },
      },
    };

    this.pushData(data);
  }

  mapProducts(cart) {
    return cart.order.map((orderItem) => {
      let price = 0;
      const product = cart.products[orderItem.productId];
      const options = cart.options[orderItem.optionsId];

      if (!product || !options) {
        return null;
      }

      price += options.processingFee || 0;
      price += options.embassyFee || 0;

      return {
        name: [
          product.country === 'US' ? product.country : product.country_name,
          product.label,
        ].join(' '),
        id: product.subtype,
        category: product.type,
        price: this.$filter('number')(price, 2),
        quantity: 1,
      };
    });
  }

  pushData(data) {
    if (this.FS && this.FS.log) {
      this.FS.log('log', data);
    } else {
      // this.$log.log(data);
    }

    if (this.dataLayer) {
      this.dataLayer.push(data);
    }
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/ecommerce.service.ts